import FileRequestModal from "@/containers/Parlor/ParlorDetailContainer/components/Modal/FileRequestModal";
import { EventPathType } from "goi_common";

interface NotLoginFileRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  path: keyof typeof EventPathType;
}

export default function NotLoginFileRequestModal(props: NotLoginFileRequestModalProps) {
  return <FileRequestModal {...props} isAdditionalInfoSelect />;
}
